import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: the intents the UI dispatches for the saga to act on.
 * Kept out of the slice's reducers: they trigger side effects (the invitation
 * check, the accept call), not state transitions (the saga owns the resulting
 * `invitationValidation*` / `submit*` transitions).
 *
 * Both carry the one-time token read from the URL by the page (router param →
 * action payload, mirroring the Reset Password slice's `submitRequested({
 * token })`; the token never enters the store).
 */

/** Resolve the invitee behind the URL token (dispatched on mount). */
export const invitationValidationRequested = createAction<{ token: string }>(
  'onboarding/invitationValidationRequested',
);

/** Submit the current draft with the URL token to activate the account. */
export const submitRequested = createAction<{ token: string }>('onboarding/submitRequested');
